export const set   = (user) => ({ type: 'SET_USER', payload: user });
export const unset = () => ({ type: 'UNSET_USER' });

export default (dispatch) => {
	return {
        set: (user) => dispatch(set(user)),
        unset: ()   => dispatch(unset())
    }
};